export const BASE_URL = 'https://digitalpassportphotos.com'; // 'http://localhost:8000'; // ;

export const ENDPOINT = BASE_URL +  "/api/home";
